// @ts-nocheck fixme type annotations

(() => {
    // section accordion on help browse
    $(".hideable").each((index, parentElement) => {
        const hider = $(parentElement).find(".hideable-title");

        $(hider).click((event) => {
            if ($(parentElement).hasClass("closed")) {
                $(parentElement).removeClass("closed");
            } else {
                $(parentElement).addClass("closed");
            }
            event.preventDefault();
        });
        return;
    });

    // open the "other" textarea when Other selected in
    $('input[name="feedback_choice"]').bind("change", (event) => {
        if (event.target.value === "other") {
            $(".expand-other-target").each((index, element) => $(element).removeClass("hidden"));
        } else {
            $(".expand-other-target").each((index, element) => $(element).addClass("hidden"));
        }
    });

    // change the visible items in the contact-us reasons list
    $(".help_contact__topic").bind("change", (event) => {
        const newSelection = event.target.value;
        let hasSelected = false;

        // can"t select until a topic is chosen
        $(".help_contact__reason").each((index, element) => $(element).removeAttr("disabled"));

        $(".help_contact__reason option").each((index, element) => {
            $(element).removeAttr("selected");
            if ($(element).data("topic") === newSelection || $(element).val() === "") {
                $(element).removeClass("hidden");
                if (!hasSelected) {
                    hasSelected = true;
                    $(element).prop("selected", "selected").change();
                }
            } else {
                $(element).addClass("hidden");
            }
        });
    });

    $(".help__feedback__no_choice").bind("change", (event) => {
        $('.help__feedback input[name="feedback_reason_submit"]').removeAttr("disabled");
    });

    $(".help_contact__reason").bind("change", (event) => {
        $('.help_contact__form input[name="feedback_reason_submit"]').removeAttr("disabled");
    });

    $("._get_help_btn_start_live_chat").click(function () {
        cedar.handleStartChatFromHelpCenter();
        if (localStorage.getItem("lastChatTimestamp") == null) {
            localStorage.setItem("lastChatTimestamp", new Date().getTime());
        }
    });
})();

export {};
